
import SlotsPage from '../Pages/SlotsPage';


const SlotsRoutes = () => {

  return (
    <SlotsPage />
  );
};

export default SlotsRoutes;

